export const GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_REQUEST = 'GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_REQUEST';

export const getAnswerInboxProcessStatementCountRequest = () => ({
    type: GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_REQUEST,
});
